export default () => {
	if($('.before-after__slider').length){
		var $beforeAfterSlider = $('.before-after__slider');

		$beforeAfterSlider.slick({
			draggable: false,
			swipe: false,
			infinite: true,
			speed: 1000,
			slidesToShow: 1,
			slidesToScroll: 1,
			fade: true,
			cssEase: 'linear',
			autoplay: false,
			autoplaySpeed: 10000,
			arrows: false,
			dots: true,
			customPaging : function(slider, i) {
				return '<button type="button" role="tab"><span>' + $(slider.$slides[i]).find('.before-after__slide').attr('data-title') + '</span></button>'; //$(slider.$slides[i]).attr('data-title')
			},
			appendDots: $('.before-after__bottom'),
		});
	}

	function toggleClassSlider () {
		let slideImage = document.querySelectorAll('.before-after__slide');

		slideImage.forEach(function(slideImg) {
			slideImg.addEventListener('click', (e)=> {
				if(!e.target.classList.contains("show")){
					e.target.classList.add("show");
				} else {
					e.target.classList.remove("show");
				}
			})
		});
	}

	toggleClassSlider ();

	function toggleNavbarMethod() {
		const noticeArrowRight = $('.notice__arrow--right');
		const noticeArrowLeft = $('.notice__arrow--left');

		noticeArrowRight.mouseover(function () {
			if ($(window).width() > 991) {
				$( this ).closest('.before-after__top').find('.before-after__slide').removeClass('show-desc');
				$( this ).closest('.before-after__top').children('.before-after__slider').find('.slick-active').children('div').find('.before-after__slide').addClass('show-desc');
			}
		});

		noticeArrowRight.mouseout(function () {
			if ($(window).width() > 991) {
				$(this).closest('.before-after__top').find('.before-after__slide').removeClass('show-desc');
			}
		});

		noticeArrowLeft.click(function (e) {
			if ($(window).width() < 992) {
				e.preventDefault();
				$( this ).closest('.before-after__top').find('.before-after__slide').removeClass('show');
			}
		});

		noticeArrowRight.click(function (e) {
			if ($(window).width() < 992) {
				e.preventDefault();
				$( this ).closest('.before-after__top').children('.before-after__slider').find('.slick-active').children('div').find('.before-after__slide').addClass('show');
			}
		});
	}

	toggleNavbarMethod();

	function imageResetClass() {
		const imageEl = $('.before-after__slide');
		imageEl.removeClass('show-desc');
		imageEl.removeClass('show');
	}


	$(window).on('resize', function () {
		toggleNavbarMethod();
		imageResetClass();
	});
}



// WEBPACK FOOTER //
// ./scripts/modules/_before-after-slider.js